module.exports = __webpack_public_path__ + "img/002709f8aab3895a.6416433f.jpeg";